// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { NLP_EVENTS } from 'shared/helpers/analytics/constants/nlp';

export const onPageLoad = (NDNPageType: string) => {
  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: NLP_EVENTS.NLP_PAGELOAD,
    data: { page: NDNPageType },
  });
};
